exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.border-mobile-active[data-v-55e80c8e]{border:2px solid #000;padding:12px;border-radius:50%}}@media (max-width: 767px){.border-mobile[data-v-55e80c8e]{border:1px solid;padding:12px;border-radius:50%}}\n", ""]);

// exports
